import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BannersFormContext } from '../../../context/banners/BannersContext';
import ImagePreview from "../../../components/preview/imagePreview";
import loadingGif from '../../../assets/uploading.gif';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";

const IP_ADDRESS = process.env.REACT_APP_URL_BACKEND;

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { postBannerData, report, patchBannerData } = useContext(BannersFormContext);
  // ID de edicion 
  const { id } = useParams();
  // Navigate to datagrid
  const navigate = useNavigate();
  // Manejo de errors
  const [errors, setErrors] = useState({})
  // Estado de Carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Dialogs de advertencia y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //MANEJO DE IMAGENES
  const [imageUrlLocal, setImageUrlLocal] = useState(null);
  const [imageUrlServer, setImageUrlServer] = useState(null);

  
  const nameData = "banners";  
  const saveData = postBannerData;
  const updateData = patchBannerData;

  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm(report);
      setImageUrlServer(report.imagen);
    }
  }, [report]);

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form, setImageUrlLocal);
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  // Mostrar diálogos
  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();
    const formData = new FormData();
    for (const key in form) {
      formData.append(key, form[key]);
    }
    try {
      if (id) {
        await updateData(id, formData);
      } else {
        await saveData(formData);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };
  
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
 <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Vista previa usando el componente ImagePreview */}
        {!isSubmitting && (
          <ImagePreview
            title="Vista previa del logo"
            imageUrl={imageUrlLocal || (imageUrlServer && `${IP_ADDRESS}${imageUrlServer}`)}
          />
        )}
        {/* Animación de cargando */}
        {isSubmitting && (
          <div className="loading-spinner">
            <img src={loadingGif} alt="Cargando..." />
          </div>
        )}
</div>

        <div className="bottom">
          <div className="right">
            <form>
              {/* Renderizado de inputs dinámicos usando FormField */}
              {Inputs.map((input) => (
                <FormField
                key={input.id}  
                fieldKey={input.id}
                input={input}
                value={form[input.name]}
                handleInputChange={handleChange}
                error={errors[input.name]}
                />
              ))}
 </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            {/* Diálogos */}
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title="Confirmación"
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              message={errorMessage}
              title="Error"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
